import { StoreSchema } from '../../types/store'

export const getDescriptionWindowState = (store: StoreSchema) =>
    store.descriptionWindow.show

export const getDescriptionWindowCoordinates = (store: StoreSchema) =>
    store.descriptionWindow.coordinates

export const getDescriptionWindowSize = (store: StoreSchema) =>
    store.descriptionWindow.size

export const getDescriptionWindowData = (store: StoreSchema) =>
    store.descriptionWindow.data